export default __webpack_public_path__ + "static/media/invoices-not-found.5b8cde40.svg";